import request from '@/utils/request'

// 查询
export function fetchList (data) {
  return request.post('/communityReview/page', data, {
    trim: true
  })
}

// 创建
export function create (data) {
  return request.post('/communityReview/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/communityReview/updateById', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/communityReview/delete/${id}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/communityReview/delete/batch', {
    params: {
      ids
    }
  })
}
